
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';


export const PaySummaryHeader = ({ title, id, collapse, setCollapse }) => {



    return (
        <div className="flex-row justify-content-between align-items-center mb-2 d-lg-none">
            <h3 className="h6 text-uppercase font-weight-bold mr-2 my-auto">{"Paiement"}</h3>
            <button className="btn-icon btn-alert bg-white navbar-toggler border-0 ml-auto rounded-max px-1" type="button" data-toggle="collapse" onClick={() => setCollapse(!collapse)} data-target={"#trierPayer" + (id)} aria-controls="trierPayer" aria-expanded="false" aria-label="Toggle navigation">
                <span className="btn-alert-primary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-1"></span>
                <span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
            </button>
        </div>
    );
};